/* eslint-disable camelcase */

// Uppdragets läge i supportmodulen. EXAKT samma värden som 1.0-dropdownen i SndMission.asp.
export enum MissionStatusEnum {
  EjPabörjad = 'Ej påbörjad',
  Pagar = 'Pågår',
  Uppskjuten = 'Uppskjuten',
  Vantar = 'Väntar',
  Slutford = 'Slutförd',
}

// En rad i supportens uppdragslista: uppdraget med kundens namn och produktionsdatumet hopslaget.
export interface BookedSendingMission {
  sndMission_id: number;
  sndCustomer_id: number;
  customerName: string;
  sndDate_id: number;
  sndDate: string;
  // "bokad" = fastställd; annat värde visas som preliminär, precis som i 1.0.
  status: string;
  missionStatus: string;
  // Uppdragstypen, t.ex. "Årsfakturering (förbund)" eller "Intresseanmäld".
  missionType?: string;
  // Äldre API-versioner levererar samma värde som Type/type (entitetens fältnamn, med eller utan camelCase
  // beroende på serialiseringen). Läses alltid via missionTypeOf.
  Type?: string;
  type?: string;
  info: string;
  deviant?: number;
  invTemplate_id?: number;
  invTitle?: string;
  supportComment?: string;
  supportUpdatedBy?: string;
}

// Uppdragstypen oavsett vilket fältnamn API:t levererar – fältet döptes om från Type till missionType.
export const missionTypeOf = (row: BookedSendingMission): string => row.missionType ?? row.Type ?? row.type ?? '';

export interface SendingMissionDate {
  sndDate_id: number;
  sndDate: string;
}

// Det som sparas från listan – uppdragets övriga fält sköts i 1.0.
export interface SndMissionSupportSave {
  sndMission_id: number;
  missionStatus: string;
  supportComment: string;
}

// Kryssrutorna speglar missionStatus: inget kryss = Ej påbörjad, fakturor skapade = Pågår, även skickade = Slutförd.
// Avbruten lagras som Uppskjuten – ett av 1.0:s befintliga lägen, så inget nytt statusvärde behöver införas.
export const invoicesCreatedFromStatus = (status: string): boolean => status === MissionStatusEnum.Pagar || status === MissionStatusEnum.Slutford;

export const invoicesSentFromStatus = (status: string): boolean => status === MissionStatusEnum.Slutford;

export const cancelledFromStatus = (status: string): boolean => status === MissionStatusEnum.Uppskjuten;

// Avbruten går före allt annat. Väntar går inte att uttrycka med kryssrutorna – det läget sätts i 1.0 och lämnas
// orört tills någon kryssar i något här.
export const statusFromChecks = (created: boolean, sent: boolean, cancelled: boolean): string => {
  if (cancelled) return MissionStatusEnum.Uppskjuten;
  if (sent) return MissionStatusEnum.Slutford;
  if (created) return MissionStatusEnum.Pagar;
  return MissionStatusEnum.EjPabörjad;
};
